import { FC } from 'react';

import { MarkerF as Marker } from '@react-google-maps/api';

import { RETAILS_MARKERS } from '../../constants';
import { City } from '../../model';
import MarkerIcon from './MarkerIcon';

type Props = {
    city: City;
    onClick: () => void;
};

export const CityMarker: FC<Props> = ({ city, onClick }) => (
    <Marker
        icon={{
            url: MarkerIcon,
            scaledSize:
                city.salons.length > 1
                    ? new google.maps.Size(RETAILS_MARKERS.size.big.width, RETAILS_MARKERS.size.big.height)
                    : new google.maps.Size(RETAILS_MARKERS.size.small.width, RETAILS_MARKERS.size.small.height),
            origin: new google.maps.Point(0, 0),
            anchor:
                city.salons.length > 1
                    ? new google.maps.Point(RETAILS_MARKERS.size.big.width / 2, RETAILS_MARKERS.size.big.height)
                    : new google.maps.Point(RETAILS_MARKERS.size.small.width / 2, RETAILS_MARKERS.size.small.height),
        }}
        position={{ lat: city.lat, lng: city.lng }}
        onClick={onClick}
        title={city.city}
    />
);
